<template>
  <container class="component-box" ref="componentBox">
    <div class="nav-list">
      <div class="nav-main">
        <v-menu
          offset-y
          open-on-hover
          v-for="menu in displayedMenus"
          :key="menu.id"
          class="header-item"
          content-class="menu-content"
          transition="slide-x-transition"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              open-on-hover
              text
              v-on="on"
              color="white"
              class="menu-button"
              :to="menu.route"
            >
              {{ menu.title }}
            </v-btn>
          </template>

          <v-list class="item-list">
            <v-list-item
              v-for="child in menu.children"
              class="menu-item"
              :key="child.id"
              router
              :to="child.route"
            >
              <div class="menu-item-title">{{ child.title }}</div>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

      <div class="nav-account">
        <v-menu
          offset-y
          open-on-hover
          v-if="accountMenu.content"
          class="header-item"
          content-class="menu-content"
          transition="slide-x-transition"
          auto
        >
          <template v-slot:activator="{ on }">
            <v-btn
              open-on-hover
              text
              v-on="on"
              color="white"
              class="menu-button"
              :to="accountMenu.route"
            >
              {{ accountMenu.title }}
            </v-btn>
          </template>
          <user-account
            v-if="accountMenu.content"
            :username="username"
            :userStatus="userStatus"
          />
        </v-menu>

        <v-btn
          v-if="!accountMenu.content"
          text
          color="white"
          class="menu-button"
          :to="accountMenu.route"
        >
          {{ accountMenu.title }}
        </v-btn>
      </div>
    </div>
  </container>
</template>

<style scoped>
@import "../assets/styles/global-styles.css";
@import "../assets/styles/variables.css";

.component-box {
  max-width: var(--page-size);
  min-width: 500px;
  margin-left: 0px;
  margin-bottom: 0px;
  margin-top: 0px;
  padding: 0px;
  background-color: var(--primary-background-color);
  width: 100%;

  border-radius: 0 0 var(--page-border-radius) var(--page-border-radius);

  z-index: 100;
  margin-left: auto;
  margin-right: auto;

  padding: 0 20px;
}

.nav-list {
  display: flex;
  align-items: center;
  width: 100%;
}

.nav-main {
  display: flex;
  justify-content: left;
  flex: 1;
  min-width: 0;
}

.nav-account {
  flex-shrink: 0;
}

.menu-button {
  min-width: 110px !important;
  padding: 10px 0.5em !important;
  font-size: 0.75em !important;
  height: unset !important;
}

.item-list {
  border-radius: 0 0 12px 12px !important;
  padding: 0 !important;
  max-width: 220px;
  overflow: hidden;
  min-width: 0 !important;
}

.menu-item {
  min-width: 0 !important;
}

.menu-item-title {
  text-overflow: ellipsis !important;
  word-wrap: break-word !important;
  white-space: nowrap;
  overflow: hidden;
}

.menu-item:last-child {
  border-radius: 0 0 12px 12px;
}

.menu-content {
  border-color: var(--primary-background-color) !important;
  border-style: solid !important;
  border-width: 0 0 0 2px !important;
  border-radius: 0 0 25px 25px !important;
}

@media only screen and (min-width: 768px) {
  .component-box {
    position: sticky;
    top: -1px;

    transition: 0.3s;
  }

  .component-box[state="2"] {
    transition: 0.01s;
    width: var(--page-size);
    box-shadow: 0 1px 7px #5555888f;
  }

  .component-box[state="3"] {
    max-width: unset;

    width: calc(100vw - 2px);
    border-radius: 0px;

    transition: 0.3s;
    box-shadow: 0 1px 7px #5555888f;
  }

  .component-box[state="4"] {
    max-width: unset;
    width: var(--page-size);
    border-radius: 0 0 var(--page-border-radius) var(--page-border-radius);
    transition: 0.3s;
    box-shadow: 0 0 0 #ffffff8f;
  }

  .component-box[state="3"] .nav-list {
    margin-left: max((100vw - var(--page-size) - 40px)/2, 0px);
    margin-right: max((100vw - var(--page-size) - 40px)/2, 0px);
    transition: 0.3s;
  }

  .component-box[state="4"] .nav-list {
    margin-left: 0;
    margin-right: 0;
    transition: 0.3s;
  }
}
</style>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { AuthenticationService } from "../services/authentication.service";
import { HeaderMenu } from "../interfaces/HeaderMenu";
import { Rubric } from "@/interfaces/Rubric.interface";
import axios from "axios";
import * as UrlConsts from "@/scripts/UrlConsts";
import { Utils } from "@/scripts/Utils";
import Container from "./Container.component.vue";
import UserAccount from "./UserAccount.component.vue";
import * as NavHeaderConsts from "@/scripts/NavHeaderConsts";
import {
  AccountMenuState,
  createBaseMenus,
  getAccountMenu,
  getDisplayedMenus,
  getUserStatusLabel,
} from "@/scripts/NavMenus";
import * as Consts from "@/scripts/Consts";

/**
 * @desc barre de navigation pour l'affichage écran d'ordinateur
 */
@Component({
  components: {
    container: Container,
    "user-account": UserAccount,
  },
})
export default class NavHeader extends Vue {
  username = "";
  userStatus = "";
  stick = false;
  loggedIn = false;
  authStatus = 0;

  menus: Array<HeaderMenu> = createBaseMenus();

  private onAuthChange = () => this.syncAuth();

  mounted(): void {
    this.init();
    this.initStick();
    this.$root.$on("login", this.onAuthChange);
    this.$root.$on("logout", this.onAuthChange);
  }

  beforeDestroy(): void {
    this.$root.$off("login", this.onAuthChange);
    this.$root.$off("logout", this.onAuthChange);
  }

  private init(): void {
    this.syncAuth();
    this.loadArticles();
    this.loadUnarchivedRubrics();
  }

  /**
   * @desc initialise la mise à jour de la propriété sticky de la barre de navigation
   */
  private initStick(): void {
    const stickyElm = (this.$refs.componentBox as Container).$el as Element;
    const observer = new IntersectionObserver(
      ([e]) => {
        if (e.intersectionRatio < 1) {
          this.stick = true;
          e.target.setAttribute("state", "2");
          setTimeout(() => {
            if (!this.stick) return;
            e.target.setAttribute("state", "3");
          }, 20);
        } else {
          this.stick = false;
          e.target.setAttribute("state", "4");
          setTimeout(() => {
            if (this.stick) return;
            e.target.setAttribute("state", "1");
          }, 400);
        }
      },

      { threshold: [1], rootMargin: "0px 2000px 0px 2000px" },
    );
    observer.observe(stickyElm);
  }

  get displayedMenus(): Array<HeaderMenu> {
    return getDisplayedMenus(this.menus, this.loggedIn, this.authStatus);
  }

  get accountMenu(): AccountMenuState {
    return getAccountMenu(this.loggedIn, "desktop");
  }

  private syncAuth(): void {
    this.loggedIn = AuthenticationService.isLoggedIn();
    this.authStatus = this.loggedIn ? AuthenticationService.getUserStatus() : 0;
    this.username = this.loggedIn ? AuthenticationService.getUsername() : "";
    this.userStatus = getUserStatusLabel(this.authStatus);
  }

  /**
   * @desc charge les derniers articles publiés
   */
  private loadArticles(): void {
    const limitArticles = 5;
    const headers = AuthenticationService.getRequestHeader();
    const query =
      "?" +
      Utils.createUrlQuery({
        limit: limitArticles,
        startDate: new Date().toString(),
      });

    axios
      .get(UrlConsts.getAllArticlesLimited + query, headers)
      .then((response) => {
        const articlesMenu = this.getMenu(NavHeaderConsts.ARTICLES_MENU);
        articlesMenu.children = response.data.map(
          (article: { id: number; title: string }) =>
            new HeaderMenu({
              title: article.title,
              id: article.id,
              route: `/article/${article.id}`,
            }),
        );
      })
      .catch((error) => console.log(error));
  }

  /**
   * @desc charge les rubriques non archivées
   */
  private loadUnarchivedRubrics(): void {
    const headers = AuthenticationService.getRequestHeader();

    axios
      .get(UrlConsts.getAllUnarchivedRubrics, headers)
      .then((response) => {
        const rubrics = response.data as Rubric[];
        const rubricMenus: HeaderMenu[] = [];
        const classMenus: HeaderMenu[] = [];

        for (const rubric of rubrics) {
          const menu = new HeaderMenu({
            title: rubric.name,
            id: rubric.id,
            route: `/rubriques/articles/${rubric.id}`,
          });
          if (rubric.type === Consts.rubric_type_schoolProject) {
            rubricMenus.push(menu);
          } else if (rubric.type === Consts.rubric_type_classroom) {
            classMenus.push(menu);
          }
        }

        this.getMenu(NavHeaderConsts.PROJECTS_MENU).children = rubricMenus;
        this.getMenu(NavHeaderConsts.CLASSES_MENU).children = classMenus;
      })
      .catch((error) => console.log(error));
  }

  private getMenu(id: number): HeaderMenu {
    return this.menus.find((x) => x.id === id) || new HeaderMenu();
  }
}
</script>
